import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import Layout from '../views/layout/Layout'

export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  {
    path: '/PatientInformation',
    component: Layout,
    redirect: '/PatientInformation/pa_info_manage',
    children: [
      {
        path: 'PatientInformationInput',
        name: 'PatientInformationInput',
        component: () => import('@/views/PatientInformation/PatientInformationInput'),
        meta: {
          title: '病人信息录入',
          icon: 'el-icon-edit'
        },
      },

      {
        path: 'NoFinshTasks',
        name: 'NoFinshTasks',
        component: () => import('@/views/PatientInformation/NoFinshTasks/NoFinshTasks'),
        meta: {
          title: '待办任务',
          icon: 'el-icon-date'
        },
      },
      {
        path: 'AllTasks',
        name: 'AllTasks',
        component: () => import('@/views/PatientInformation/AllTasks'),
        meta: {
          title: '总任务',
          icon: 'el-icon-date'
        },
      },

      {
        path: 'PatientInformationManagement',
        name: 'PatientInformationManagement',
        component: () => import('@/views/PatientInformation/PatientInformationManagement'),
        meta: {
          title: '病人信息管理',
          icon: 'el-icon-user'
        },
      },
      {
        path: 'pa_info_manage',
        name: 'pa_info_manage',
        component: () => import('@/views/PatientInformation/pa_info_manage'),
        meta: {
          title: '病人信息管理新',
          icon: 'el-icon-user'
        },
      },
      {
        path: 'outpatientInformationInput',
        name: 'outpatientInformationInput',
        component: () => import('@/views/PatientInformation/outpatientInformationInput'),
        meta: {
          title: '门诊信息录入',
          icon: 'el-icon-edit'
        },
      },
    ]
  },

  {
    path: '/CustomerServiceInformation',
    component: Layout,
    redirect: '/CustomerServiceInformation',
    meta: {
      title: '客服信息',
      icon: 'el-icon-user'
    },
    children: [
      {
        path: 'PersonalInformationManagement',
        name: 'PersonalInformationManagement',
        component: () => import('@/views/CustomerServiceInformation/PersonalInformationManagement'),
        meta: {
          title: '个人信息管理',
          icon: 'el-icon-circle-plus-outline'
        },
      },
      {
        path: 'CustomerServiceManagement',
        name: 'CustomerServiceManagement',
        component: () => import('@/views/CustomerServiceInformation/CustomerServiceManagement'),
        meta: {
          title: '客服信息管理',
          icon: 'el-icon-connection'
        },
      },
      {
        path: 'CustomerServiceInput',
        name: 'CustomerServiceInput',
        component: () => import('@/views/CustomerServiceInformation/CustomerServiceInput'),
        meta: {
          title: '客服信息录入',
          icon: 'el-icon-edit-outline'
        },
      },

      {
        path: 'InterfaceSettings',
        name: 'InterfaceSettings',
        component: () => import('@/views/CustomerServiceInformation/InterfaceSettings'),
        meta: {
          title: '界面设置',
          icon: 'el-icon-circle-plus-outline'
        },
      }
    ]
  },
  {
    path: '/Report',
    component: Layout,
    redirect: '/Report',
    children: [
      {
        path: 'achievement',
        name: 'achievement',
        component: () => import('@/views/Report/achievement'),
        meta: {
          title: '业绩报表',
          icon: 'el-icon-circle-plus-outline'
        }
      },
      {
        path: 'visitReport',
        name: 'visitReport',
        component: () => import('@/views/Report/visitReport'),
        meta: {
          title: '回访报表',
          icon: 'el-icon-circle-plus-outline'
        }
      },

      {
        path: 'AgainTreatment',
        name: 'AgainTreatment',
        component: () => import('@/views/Report/AgainTreatment'),
        meta: {
          title: '复诊报表',
          icon: 'el-icon-circle-plus-outline'
        }
      },

      {
        path: 'DoctorsRankVisit',
        name: 'DoctorsRankVisit',
        component: () => import('@/views/Report/DoctorsRankVisit'),
        meta: {
          title: '医生排名',
          icon: 'el-icon-medal-1'
        }
      },

      {
        path: 'RecordingReport',
        name: 'RecordingReport',
        component: () => import('@/views/Report/RecordingReport'),
        meta: {
          title: '录音报表',
          icon: 'el-icon-circle-plus-outline'
        }
      },

      {
        path: 'firstMoneyReport',
        name: 'firstMoneyReport',
        component: () => import('@/views/Report/firstMoneyReport'),
        meta: {
          title: '初诊消费报表(脑病）',
          icon: 'el-icon-s-claim'
        }
      },

      {
        path: 'gradeMoneyReport',
        name: 'gradeMoneyReport',
        component: () => import('@/views/Report/gradeMoneyReport'),
        meta: {
          title: '等级消费报表',
          icon: 'el-icon-s-claim'
        }
      },

      {
        path: 'RecordingInformation',
        name: 'RecordingInformation',
        component: () => import('@/views/Report/RecordingInformation'),
        meta: {
          title: '录音信息',
          icon: 'el-icon-circle-plus-outline'
        }
      },

      {
        path: 'diseaseStatistics',
        name: 'diseaseStatistics',
        component: () => import('@/views/Report/diseaseStatistics'),
        meta: {
          title: '渠道报表',
          icon: 'el-icon-circle-plus-outline'
        }
      },

      {
        path: 'ImplantStatistics',
        name: 'ImplantStatistics',
        component: () => import('@/views/Report/ImplantStatistics'),
        meta: {
          title: '靶向报表',
          icon: 'el-icon-s-claim'
        }
      },


      {
        path: 'channelReport',
        name: 'channelReport',
        component: () => import('@/views/Report/channelReport'),
        meta: {
          title: '诊室报表',
          icon: 'el-icon-circle-plus-outline'
        }
      },

      {
        path: 'deadOrderReport',
        name: 'deadOrderReport',
        component: () => import('@/views/Report/deadOrderReport'),
        meta: {
          title: '各类状态报表',
          icon: 'el-icon-circle-plus-outline'
        }
      },

      {
        path: 'initialReplyReport',
        name: 'initialReplyReport',
        component: () => import('@/views/Report/initialReplyReport'),
        meta: {
          title: '初复诊比报表',
          icon: 'el-icon-picture-outline-round'
        }
      },

      {
        path: 'robotReport',
        name: 'robotReport',
        component: () => import('@/views/Report/robotReport'),
        meta: {
          title: '机器人报表',
          icon: 'el-icon-s-claim'
        }
      },

      {
        path: 'medicationPlanning',
        name: 'medicationPlanning',
        component: () => import('@/views/Report/medicationPlanning'),
        meta: {
          title: '寄药报表',
          icon: 'el-icon-circle-plus-outline'
        }
      },

      {
        path: 'comprehensiveAnalysisReport',
        name: 'comprehensiveAnalysisReport',
        component: () => import('@/views/Report/comprehensiveAnalysisReport'),
        meta: {
          title: '综合分析报表',
          icon: 'el-icon-circle-plus-outline'
        }
      },


      {
        path: 'NonOutgoingReport',
        name: 'NonOutgoingReport',
        component: () => import('@/views/Report/NonOutgoingReport'),
        meta: {
          title: '非出报表',
          icon: 'el-icon-circle-plus-outline'
        }
      },

      {
        path: 'SurgicalReport',
        name: 'SurgicalReport',
        component: () => import('@/views/Report/SurgicalReport'),
        meta: {
          title: '手术报表',
          icon: 'el-icon-scissors'
        }
      },

      {
        path: 'satisfactionReport',
        name: 'satisfactionReport',
        component: () => import('@/views/Report/satisfactionReport'),
        meta: {
          title: '满意度报表',
          icon: 'el-icon-star-on'
        }
      },

    ]
  },


  {
    path: '/SystemManagement',
    component: Layout,
    redirect: '/SystemManagement',
    children: [
      {
        path: 'MenuManagement',
        name: 'MenuManagement',
        component: () => import('@/views/SystemManagement/MenuManagement'),
        meta: {title: '菜单管理',},
      },
      {
        path: 'UserManagement',
        name: 'UserManagement',
        component: () => import('@/views/SystemManagement/UserManagement/UserManagement'),
        meta: {title: '用户管理'}
      },
      {
        path: 'Role',
        name: 'Role',
        component: () => import('@/views/SystemManagement/Role'),
        meta: {title: '角色管理'}
      },
      {
        path: 'Divisional',
        name: 'Divisional',
        component: () => import('@/views/SystemManagement/Divisional'),
        meta: {title: '部门管理'}
      },

      {
        path: 'HospitalManagement',
        name: 'HospitalManagement',
        component: () => import('@/views/SystemManagement/HospitalManagement'),
        meta: {
          title: '医院管理',
          icon: 'el-icon-office-building'
        },
      },

      {
        path: 'UserPopup',
        name: 'UserPopup',
        component: () => import('@/views/SystemManagement/UserManagement/UserPopup'),
        meta: {title: '用户列表'}
      },
      {
        path: 'sys_remind',
        name: 'sys_remind',
        component: () => import('@/views/SystemManagement/sys_remind'),
        meta: {title: '提醒设置'}
      },
    ]
  },

  {
    path: '/DataDictionary',
    component: Layout,
    redirect: '/DataDictionary',
    children: [
      {
        path: 'DictionaryManagement',
        name: 'DictionaryManagement',
        component: () => import('@/views/DataDictionary/DictionaryManagement'),
        meta: {title: '字典管理'}
      },
      {
        path: 'TypeManagement',
        name: 'TypeManagement',
        component: () => import('@/views/DataDictionary/TypeManagement'),
        meta: {title: '类型管理'}
      },

      {
        path: 'channelMangement',
        name: 'channelMangement',
        component: () => import('@/views/DataDictionary/channelMangement'),
        meta: {title: '渠道管理'}
      },

      {
        path: 'clinicMangement',
        name: 'clinicMangement',
        component: () => import('@/views/DataDictionary/clinicMangement'),
        meta: {title: '科室与疾病管理'}
      },

      {
        path: 'WhiteUserList',
        name: 'WhiteUserList',
        component: () => import('@/views/DataDictionary/WhiteUserList'),
        meta: {title: '白名单管理'}
      },

    ]
  },
  {
    path: '/GroupHospitalOne',
    component: Layout,
    redirect: '/GroupHospitalOne',
    children: [
      {
        path: 'AHospitalReVisitRanking',
        name: 'AHospitalReVisitRanking',
        component: () => import('@/views/GroupHospitalOne/AHospitalReVisitRanking'),
        meta: {title: '医院复诊排名', icon: 'el-icon-s-flag'},
      },
      {
        path: 'SumZyLRanking',
        name: 'SumZyLRanking',
        component: () => import('@/views/GroupHospitalOne/SumZyLRanking'),
        meta: {title: '医院住院率', icon: 'el-icon-s-flag'},
      },
      {
        path: 'ConsumptionRanking',
        name: 'ConsumptionRanking',
        component: () => import('@/views/GroupHospitalOne/ConsumptionRanking'),
        meta: {title: '医院收入', icon: 'el-icon-s-flag'},
      },
      {
        path: 'gradeMoneyReport',
        name: 'gradeMoneyReport',
        component: () => import('@/views/GroupHospitalOne/gradeMoneyReport'),
        meta: {title: '医院等级消费', icon: 'el-icon-s-flag'},
      },
      {
        path: 'XwfyBzRanking',
        name: 'XwfyBzRanking',
        component: () => import('@/views/GroupHospitalOne/XwfyBzRanking'),
        meta: {title: '行为发育科病种占比', icon: 'el-icon-s-flag'},
      },
    ]
  },

  {
    path: '/GroupHospital',
    component: Layout,
    redirect: '/GroupHospital',
    children: [
      {
        path: 'ADoctorsReVisitRanking',
        name: 'ADoctorsReVisitRanking',
        component: () => import('@/views/GroupHospital/ADoctorsReVisitRanking'),
        meta: {title: '医生复诊排名', icon: 'el-icon-s-flag'},
      },
      {
        path: 'ACustomerVisitRanking',
        name: 'ACustomerVisitRanking',
        component: () => import('@/views/GroupHospital/ACustomerVisitRanking'),
        meta: {title: '客服复诊排名', icon: 'el-icon-s-flag'},
      },

      {
        path: 'SumZyLRanking',
        name: 'SumZyLRanking',
        component: () => import('@/views/GroupHospital/SumZyLRanking'),
        meta: {title: '总住院率排名', icon: 'el-icon-school'},
      },
      {
        path: 'ConsumptionRanking',
        name: 'ConsumptionRanking',
        component: () => import('@/views/GroupHospital/ConsumptionRanking'),
        meta: {title: '医生收入排名', icon: 'el-icon-discover'},
      },
      {
        path: 'FirstAndVisitRanking',
        name: 'FirstAndVisitRanking',
        component: () => import('@/views/GroupHospital/FirstAndVisitRanking'),
        meta: {title: '初复诊比排名', icon: 'el-icon-odometer'},
      },
    ]
  },

  {
    path: '/EveryOneHospitalRank',
    component: Layout,
    redirect: '/EveryOneHospitalRank',
    children: [
      {
        path: 'DoctorVisitRanking',
        name: 'DoctorVisitRanking',
        component: () => import('@/views/EveryOneHospitalRank/DoctorVisitRanking'),
        meta: {title: '医生复诊排名', icon: 'el-icon-s-flag'},
      },
      {
        path: 'CustomerVisitRanking',
        name: 'CustomerVisitRanking',
        component: () => import('@/views/EveryOneHospitalRank/CustomerVisitRanking'),
        meta: {title: '客服复诊排名', icon: 'el-icon-school'},
      },
      {
        path: 'DoctorZylRanking',
        name: 'DoctorZylRanking',
        component: () => import('@/views/EveryOneHospitalRank/DoctorZylRanking'),
        meta: {title: '医生住院率', icon: 'el-icon-discount'},
      },
      {
        path: 'DoctorMoneyRanking',
        name: 'DoctorMoneyRanking',
        component: () => import('@/views/EveryOneHospitalRank/DoctorMoneyRanking'),
        meta: {title: '医生收入排名', icon: 'el-icon-discover'},
      },

      {
        path: 'XwfyBzRanking',
        name: 'XwfyBzRanking',
        component: () => import('@/views/EveryOneHospitalRank/XwfyBzRanking'),
        meta: {title: '行为发育科病种占比', icon: 'el-icon-share'},
      },

    ]
  },


  {
    path: '*',
    redirect: '/404',
    hidden: true
  },

  {
    path: '/OperationManagement',
    component: Layout,
    redirect: '/OperationManagement',
    children: [
      {
        path: 'operationmanagement',
        name: 'operationmanagement',
        component: () => import('@/views/OperationManagement/operationmanagement'),
        meta: {
          title: '消息列表',
          icon: 'el-icon-data-analysis'
        }
      }
    ]
  },


]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js